<template>
  <div class="login__content-wrap">
    <h1 class="text-size-md layout--margin-bottom-sm weight--normal">
      {{ title }}
    </h1>
    <p class="text-size-default layout--margin-bottom-xl">
      {{ copy }}
    </p>
    <form
      v-if="!done"
      v-on:submit.prevent="handleSubmit"
      class="layout--margin-bottom-lg"
    >
      <div class="input-group__field-wrap input-group__field-wrap--wide">
        <label for="newPassword" class="input-group__label">New Password</label>
        <input
          id="newPassword"
          :type="hidePassword ? 'password' : 'text'"
          class="input-group__input"
          :class="{
            'input-group__input--error':
              $v.newPassword.$invalid && $v.newPassword.$dirty,
          }"
          v-model="newPassword"
          aria-required="true"
          :aria-invalid="$v.newPassword.$invalid && $v.newPassword.$dirty"
        />
        <DisclosureButton
          target="newPassword"
          :hide="hidePassword"
          :showAction="toggleShowPassword"
          :hideAction="toggleHidePassword"
        />
        <Error
          :invalid="!$v.newPassword.required && $v.newPassword.$dirty"
          message="Please enter a new password"
        />
        <Error
          :invalid="!$v.newPassword.minLength && $v.newPassword.$dirty"
          message="Password needs to be at least 8 characters"
        />
      </div>
      <div class="input-group__field-wrap input-group__field-wrap--wide">
        <label for="reEnterNewPassword" class="input-group__label"
          >Re-Enter New Password</label
        >
        <input
          id="reEnterNewPassword"
          :type="hideRepeatPassword ? 'password' : 'text'"
          class="input-group__input"
          :class="{
            'input-group__input--error':
              $v.reEnterNewPassword.$invalid && $v.reEnterNewPassword.$dirty,
          }"
          v-model="reEnterNewPassword"
          aria-required="true"
          :aria-invalid="
            $v.reEnterNewPassword.$invalid && $v.reEnterNewPassword.$dirty
          "
        />
        <DisclosureButton
          target="reEnterNewPassword"
          :hide="hideRepeatPassword"
          :showAction="toggleShowRepeatPassword"
          :hideAction="toggleHideRepeatPassword"
        />
        <Error
          :invalid="
            !$v.reEnterNewPassword.required && $v.reEnterNewPassword.$dirty
          "
          message="Please re-enter the new password"
        />
        <Error
          :invalid="
            !$v.reEnterNewPassword.sameAsNewPassword &&
              $v.reEnterNewPassword.$dirty
          "
          message="Please make sure the two passwords match"
        />
      </div>
      <LoadingButton
        type="submit"
        class="button button--big button--wide layout--margin-top-xs layout--margin-bottom-xs"
        :loading="$wait.is('changing password')"
        label="Reset Password"
        loadingLabel="Please wait..."
        :doneLoading="done"
        doneLoadingLabel="Done!"
      />
      <div class="input-group__error" v-if="error" role="alert">
        Error resetting password. Please try again later.
      </div>
    </form>
    <router-link
      :to="{ name: 'login' }"
      class="button button--big button--wide"
      v-if="done"
      >Return to Login</router-link
    >
  </div>
</template>

<script>
import { required, sameAs, minLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import { mapWaitingActions } from "vue-wait";

import LoadingButton from "../../components/LoadingButton";
import DisclosureButton from "../../components/DisclosureButton";
import Error from "../../components/Error";

export default {
  name: "change-password",
  components: {
    LoadingButton,
    Error,
    DisclosureButton,
  },
  data() {
    return {
      done: false,
      error: false,
      reEnterNewPassword: "",
      newPassword: "",
      hidePassword: true,
      hideRepeatPassword: true,
    };
  },
  methods: {
    ...mapWaitingActions("account", {
      changePasswordWithToken: "changing password",
    }),
    handleSubmit: function() {
      console.log("submit!");
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const payload = {
          newPassword: this.newPassword,
          token: this.$route.query.Token,
        };
        this.changePasswordWithToken(payload).then(() => {
          this.$v.$reset();
          this.done = true;
        });
      }
    },
    toggleHidePassword() {
      this.hidePassword = true;
    },
    toggleShowPassword() {
      this.hidePassword = false;
    },
    toggleHideRepeatPassword() {
      this.hideRepeatPassword = true;
    },
    toggleShowRepeatPassword() {
      this.hideRepeatPassword = false;
    },
  },
  computed: {
    title: function() {
      if (!this.done) {
        return "Reset your password";
      }
      return "Success!";
    },
    copy: function() {
      if (!this.done) {
        return "Almost done. Enter your new password, and you're all set.";
      }
      return "Your password has been reset.";
    },
  },
  validations: {
    newPassword: {
      required,
      minLength: minLength(8),
    },
    reEnterNewPassword: {
      required,
      sameAsNewPassword: sameAs("newPassword"),
    },
  },
};
</script>

<style></style>
